import { Popover } from "react-tiny-popover";
import { useState } from "react";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";

export default function EmojiPicker({
  onAddEmoji,
}: {
  onAddEmoji: (emoji: string) => void;
}) {
  const [open, setOpen] = useState(false);

  return (
    <Popover
      isOpen={open}
      positions={["top", "right"]}
      align={"start"}
      containerStyle={{ zIndex: "100000000" }}
      padding={7}
      onClickOutside={() => setOpen(false)}
      content={
        <Picker
          theme="light"
          data={data}
          onEmojiSelect={(e: any) => {
            onAddEmoji(e.native);
            setOpen(false);
          }}
        />
      }
    >
      <button
        onClick={() => setOpen(!open)}
        className="button has-text-primary is-ghost is-no-box-shadow"
      >
				{/* <FaRegSmile/> */}
        <span style={{ position: "absolute" }} className="icon">
          <img src="/assets/emoji.svg" alt="" />
        </span>
      </button>
    </Popover>
  );
}
